/* eslint-disable comma-dangle */
/* eslint-disable quotes */
/* eslint-disable quote-props */

var deprecateInaccessibleColor = {
  "background": {
    "deprecated.neutral.4": "#eff4fc",
    "deprecated.neutral.5": "#5e6b82",
    "deprecated.neutral.alpha-1": "rgba(4, 7, 10, 0.24)",
    "deprecated.neutral.disabled-1": "rgba(37, 44, 56, 0.08)",
    "deprecated.neutral.disabled-2": "rgba(37, 44, 56, 0.08)",
    "deprecated.neutral.disabled-3": "rgba(37, 44, 56, 0.08)",
    "deprecated.neutral.disabled-4": "rgba(37, 44, 56, 0.08)",
    "deprecated.primary.brand": "#2067da",
    "deprecated.primary.citycenter": "#2067da",
    "deprecated.primary.easycancel": "#e5efff",
    "deprecated.primary.golocal": "#2067da",
    "deprecated.primary.map-landmark": "#2067da",
    "deprecated.primary.map-shopping": "#2067da",
    "deprecated.primary.map-transportation": "#2067da",
    "deprecated.primary.new": "#2067da",
    "deprecated.primary.preferred": "#2067da"
  },
  "border": {
    "deprecated.neutral.4": "#5e6b82",
    "deprecated.neutral.disabled-1": "#5e6b82",
    "deprecated.primary.preferred": "#2067da"
  },
  "text": {
    "deprecated.neutral.disabled-2": "rgba(37, 44, 56, 0.24)",
    "deprecated.primary.easycancel": "#2067da",
    "deprecated.primary.golocal": "#ffffff",
    "deprecated.primary.vip-gold": "#ffffff",
    "deprecated.secondary.interactive": "#252c38"
  }
};

export { deprecateInaccessibleColor as default };
//# sourceMappingURL=deprecateInaccessibleColor.js.map
